<!-- css设置 -->
<template>
  <div class="css-setting" data-test="css-setting">
    <div class="class-list">
      <class-item :item="item" v-for="(item, index) in list" :key="index">
        <van-button square round size="small" type="primary">去排课</van-button>
      </class-item>
    </div>
    <div class="wrapper" v-if="$route.query.type=='theme'">
      <div class="theme-list">
        <div
          class="theme-0 dot"
          :class="{ active: theme == 0 }"
          @click="changTheme(0)"
        ></div>
        <div
          class="theme-1 dot"
          :class="{ active: theme == 1 }"
          @click="changTheme(1)"
        ></div>
        <div
          class="theme-2 dot"
          :class="{ active: theme == 2 }"
          @click="changTheme(2)"
        ></div>
        <div
          class="theme-3 dot"
          :class="{ active: theme == 3 }"
          @click="changTheme(3)"
        ></div>
      </div>
      <van-button square round block type="primary" class="btn" @click="saveTheme" data-test="css-setting-btn-saveTheme">保存</van-button
      >
    </div>
    <div class="wrapper" v-else>
        <div class="slider-wrapper">
            <div class="word">
                <span class="small">A(标准)</span>
                <span class="normal">A(大号)</span>
                <span class="big">A(特大号)</span>
            </div>
            <van-slider v-model="fontStep" :step="50" @change="changFont"/>
        </div>
        <van-button square round block type="primary" class="btn" @click="saveFont" data-test="css-setting-btn-saveFont">保存</van-button
      >
    </div>
  </div>
</template>

<script>
import ClassItem from "@teacher/components/class-item.vue";
export default {
  props: {
    type: String,
  },
  computed: {
    pageTitle() {
      return this.$route.query && this.$route.query.type == "font"
        ? "设置字体大小"
        : "设置主题颜色";
    },
  },
  components: {
    ClassItem,
  },
  data() {
    return {
      theme: 0,
      font:0,
      fontStep:0,
      list: [
        {
          id: 327401,
          className: "五年级数学暑假双师系统班",
          campusName: "岳麓校区",
          priceItemName: "[数学]五年级·暑期·双师",
          fullClassNum: 50,
          currentClassNum: 20,
          attendClassTeacher: "李老师",
          classStatus: 0,
          curriculumName: "通用课",
        },
        {
          id: 327402,
          className: "五年级语文暑假双师系统班",
          campusName: "岳麓校区",
          priceItemName: "[语文]五年级·暑期·双师",
          fullClassNum: 50,
          currentClassNum: 30,
          attendClassTeacher: "刘老师",
          classStatus: 0,
          curriculumName: "通用课",
        },
      ],
    };
  },
  methods: {
    changTheme(index) {
      this.theme = index;
      app._cssVar.themeChange(this.theme);
    },
    changFont(step) {    
      this.font = step == 0 ? 0 : step == 50 ? 1 : 2;
      app._cssVar.fontChange(this.font);
    },
    saveTheme() {
      app._cssVar.themeChange(this.theme, true);
      this.$router.back();
    },
    saveFont() {
      app._cssVar.fontChange(this.font, true);
      this.$router.back();
    },
  },
  created() {
    this.theme = app._cssVar.getTheme();
    this.font = app._cssVar.getFont();
    this.fontStep = this.font == 1 ? 50 : this.font == 2 ? 100 : 0;
  },
};
</script>

<style lang="scss" scoped>
.css-setting {
  position: relative;
  background: var(--g2);
  height: 100%;
  .class-list {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .class-item-wrapper {
      flex: 1;
      padding: calc(var(--gap) * 12) 0;
      overflow-y: auto;
    }
  }
  .wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 185px;
    width: 100%;
    background: var(--white);
    padding: 0 16px;
    .theme-list {
      margin-top: 50px;
      display: flex;
      justify-content: space-around;
      .dot {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        box-sizing: content-box;
        border: 4px solid #fff;
        &.active {
          box-shadow: 0px 2px 12px 0px rgba(100, 101, 102, 0.12);
          border: 4px solid #dcdee0;
        }
      }
      .theme-0 {
        background: #2284fe;
      }
      .theme-1 {
        background: #F5222D ;
      }
      .theme-2{
          background: #FA8C16 ;
      }
      .theme-3{
          background: #13C2C2  ;
      }
    }
    .slider-wrapper{
        height: 70px;
        padding:30px;
        .word{
            line-height:28px;
            height:28px;
            margin-bottom:12px;
            display:flex;
            align-items: center;
            justify-content: space-between;
            .small{
                font-size:14px;
            }
            .normal{
                font-size: 16px;
            }
            .big{
                font-size: 18px;
            }
        }
    }
    .btn {
      position: absolute;
      bottom: 5px;
      width: calc(100% - 32px);
      font-size: 16px;
    }
  }
}
</style>